import { Component, OnInit, AfterViewInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { RegisterComponent } from '../register/register.component';

@Component({
  selector: 'app-registration-holder',
  templateUrl: './registration-holder.component.html',
  styleUrls: ['./registration-holder.component.scss']
})
export class RegistrationHolderComponent implements OnInit, AfterViewInit {

  ngAfterViewInit(): void {
    const dialogRef = this.dialog.open(RegisterComponent, {
      width: "650px",
      disableClose: false,
      panelClass: "registerComponentPanel",
      height: "auto"
    })

    dialogRef.afterClosed().subscribe(v=>{
      if(!dialogRef.componentInstance.afterRegClose)
      {
          window.history.back();
      }
    
    })

  }

  constructor(
    public dialog: MatDialog
  ) { }

  ngOnInit() {
  }

}
